import { CalendarDotsIcon as PhosphorCalendarDotsIcon } from "@phosphor-icons/react/dist/ssr/CalendarDots";

import { createAppIcon } from "@/components/createAppIcon";

export const CalendarIcon = /* @__PURE__ */ createAppIcon(PhosphorCalendarDotsIcon);
